var onyx = "/static/193a36000f76e43b.png";

export { onyx as default };
//# sourceMappingURL=onyx.png.js.map
